import { HeaderPage } from "../../../components/header-page/HeaderPage";
import { BreadcrumbItem } from "../../../components/common/breadcrumbs/Breadcrumbs";

const breadcrumbItems: BreadcrumbItem[] = [
  { label: "Dsitribuidores", href: "/dashboard/distributors" },
  { label: "Categorías de Distribuidores" },
];

export const DistributorTypeHeader = () => {
  return (
    <HeaderPage
      title="Categorías de Distribuidores"
      breadcrumbItems={breadcrumbItems}
    />
  );
};
